module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/iphone-xr-28884dc11f1bd287db7f5f518cdc016d.svg";